import { PreviousProductType } from "../../types"

class RegisteredProductForChangeProgram{
    productCode!: string
    amountPaidByUser!: number
    isAdvanceProduct!:boolean
    productDisplayName!: string | null
    constructor(productObject:PreviousProductType){
        this.productCode = productObject.product_code
        this.amountPaidByUser = productObject.amount_paid_by_user
        this.isAdvanceProduct = productObject.is_advance_product
        this.productDisplayName =  productObject.product_display_name 
    }
}

export default RegisteredProductForChangeProgram